<template>
  <div class="bet-accumulator">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <FixturesScreenshot type="accumulator">
      <div>
        <!-- HEADER -->
        <div class="header">
          <div class="header-decorations">
            <div class="decoration decoration-1">🎯</div>
            <div class="decoration decoration-2">💰</div>
            <div class="decoration decoration-3">⚡</div>
          </div>

          <div class="header-content">
            <div class="logo-container">
              <img src="@/assets/img/bxb.png" class="logo" />
            </div>

            <h1 class="title">
              {{ bet.title }}
            </h1>

            <div v-if="bet.returnedCoin > 0" class="winnings">
              +{{ bet.returnedCoin.toLocaleString() }} Ks
            </div>

            <div class="win-count-badge">
              {{ bet.winTeamsCount }}
            </div>

            <p class="description">
              {{ bet.body }}
            </p>
          </div>
        </div>

        <!-- SUMMARY -->
        <div class="summary">
          <div class="summary-item">
            <p class="summary-value roi">{{ bet.roi }}</p>
            <p class="summary-label">ROI</p>
          </div>
          <div class="summary-item">
            <p class="summary-value accuracy">{{ bet.accuracy }}</p>
            <p class="summary-label">Accuracy</p>
          </div>
          <div class="summary-item">
            <p class="summary-value count">{{ bet.itemsCount }}</p>
            <p class="summary-label">မောင်း</p>
          </div>
        </div>

        <!-- WINNING PICKS -->
        <div class="picks-container">
          <div class="picks-header">⚡ Winning Picks</div>

          <div class="picks-list">
            <div
              v-for="(fixture, idx) in bet.predictions"
              :key="idx"
              :class="['pick-card', isWin(fixture) ? 'win' : 'lose']"
            >
              <!-- Header Row -->
              <div class="pick-header">
                <div class="teams">
                  <div>
                    {{ fixture.homeTeam }}
                    <span
                      v-if="
                        fixture.predictionType === 'body' &&
                        fixture.isHomeTeamUpper
                      "
                      class="handicap"
                    >
                      ({{
                        oddsInfi(fixture.handicapValue, fixture.handicapPrice)
                      }})
                    </span>
                  </div>
                  <div class="vs">vs</div>
                  <div>
                    {{ fixture.awayTeam }}
                    <span
                      v-if="
                        fixture.predictionType === 'body' &&
                        !fixture.isHomeTeamUpper
                      "
                      class="handicap"
                    >
                      ({{
                        oddsInfi(fixture.handicapValue, fixture.handicapPrice)
                      }})
                    </span>
                  </div>
                </div>

                <!-- WIN / LOSE Badge -->
                <div
                  :class="[
                    'status-badge',
                    isWin(fixture) ? 'win-badge' : 'lose-badge',
                  ]"
                >
                  <i v-if="isWin(fixture)" class="fas fa-check check-icon"></i>
                  {{ fixture.statusString }}
                </div>
              </div>

              <!-- Score + Prediction -->
              <div class="pick-footer">
                <div class="score">
                  {{ fixture.score }}
                </div>

                <div
                  v-if="fixture.predictionType === 'goal_total'"
                  class="prediction"
                >
                  {{ fixture.predictionSide }}
                  <span class="prediction-odds">
                    ({{
                      oddsInfi(fixture.handicapValue, fixture.handicapPrice)
                    }})
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FixturesScreenshot>
  </div>
</template>

<script>
import FixturesScreenshot from "@/components/FixturesScreenshot.vue";
import { mapActions } from "vuex";
export default {
  name: "BetAccumulator",
  data() {
    return {
      requestId: "",
      isLoading: false,
      fullPage: true,
      bet: {},
    };
  },
  components: {
    FixturesScreenshot,
  },
  methods: {
    ...mapActions({
      getShareData: "getShareData",
    }),
    oddsInfi(value, price) {
      return `${value > 0 ? "+" : ""}${value}/${price}`;
    },
    isWin(fixture) {
      return fixture.status === "full_win" || fixture.status === "partial_win";
    },
    async fetchShare() {
      this.isLoading = true;
      let option = {
        id: this.requestId,
      };

      await this.getShareData({ ...option })
        .then((res) => {
          this.bet = res.data;
        })
        .catch((err) => console.error(err))
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
  async mounted() {
    this.requestId = this.$route.query.id;
    this.fetchShare();
  },
};
</script>

<style scoped>
.bet-accumulator {
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 400px;
  height: 100%;
  background-color: #ffffff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
}

/* Header Styles */
.header {
  position: relative;
  overflow: hidden;
  background: linear-gradient(to bottom right, #facc15, #eab308, #f97316);
  padding: 32px;
  text-align: center;
}

.header-decorations {
  position: absolute;
  inset: 0;
  opacity: 0.2;
}

.decoration {
  position: absolute;
}

.decoration-1 {
  top: 16px;
  left: 16px;
  font-size: 3.5rem;
}

.decoration-2 {
  top: 32px;
  right: 32px;
  font-size: 3rem;
}

.decoration-3 {
  bottom: 16px;
  left: 25%;
  font-size: 2.5rem;
}

.header-content {
  position: relative;
  z-index: 10;
}

.logo-container {
  display: inline-flex;
  height: 80px;
  width: 120px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-bottom: 24px;
}

.logo {
   width: 100%;
  height: 100%;
  object-fit: contain;
}

.title {
  margin-bottom: 8px;
  font-size: 1.5rem;
  line-height: 2.5rem;
  font-weight: 900;
  color: #1e3a8a;
}

.winnings {
  font-size: 1.5rem;
  font-weight: 900;
  color: #1e3a8a;
}

.win-count-badge {
  display: inline-block;
  margin-top: 12px;
  border-radius: 9999px;
  background-color: #1e3a8a;
  padding: 8px 24px;
  font-size: 1.125rem;
  font-weight: 700;
  color: #facc15;
}

.description {
  margin-top: 16px;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e3a8a;
}

/* Summary Styles */
.summary {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid #f3f4f6;
  background-color: #ffffff;
  padding: 16px 0;
  text-align: center;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary-value {
  font-weight: 700;
}

.summary-value.roi {
  color: #007aff;
}

.summary-value.accuracy {
  color: #00c853;
}

.summary-value.count {
  color: #ef4444;
}

.summary-label {
  margin-top: 4px;
  font-size: 0.75rem;
  color: #60a5fa;
}

/* Picks Styles */
.picks-container {
  background-color: #ffffff;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.picks-header {
  margin-top: 12px;
  margin-left: 12px;
  text-align: left;
  font-size: 0.875rem;
  font-weight: 600;
  color: #374151;
}

.picks-list {
  flex: 1;
  overflow-y: auto;
  padding: 12px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pick-card {
  display: flex;
  flex-direction: column;
  border-radius: 0.75rem;
  border: 1px solid;
  padding: 16px 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

.pick-card.win {
  border-color: #4ade80;
  background-color: #f0fdf4;
}

.pick-card.lose {
  border-color: #f87171;
  background-color: #fef2f2;
}

.pick-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.teams {
  font-size: 0.875rem;
  line-height: 1.25;
  font-weight: 700;
  color: #1f2937;
}

.handicap {
  color: #93c5fd;
}

.vs {
  color: #6b7280;
}

.status-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  padding: 2px 8px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: 700;
}

.win-badge {
  background-color: #dcfce7;
  color: #15803d;
}

.lose-badge {
  background-color: #fecaca;
  color: #b91c1c;
}

.check-icon {
  color: #16a34a;
  font-size: 0.625rem;
}

.pick-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.score {
  margin-bottom: 4px;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 900;
  color: #16a34a;
}

.prediction {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.5rem;
  background-color: rgba(255, 255, 255, 0.2);
  font-size: 0.875rem;
  font-weight: 700;
  color: #000000;
  backdrop-filter: blur(4px);
}

.prediction-odds {
  color: #a855f7;
}
</style>

// bet: { // title: "🔥 Weekend Accumulator", // body: "A mix of Premier League
and Serie A fixtures — massive winnings incoming!", // roi: "+145%", //
accuracy: "83%", // itemsCount: 5, // returnedCoin: 120000, // winTeamsCount:
"4/5 Win", // predictions: [ // { // homeTeam: "Liverpool", // awayTeam:
"Arsenal", // handicapValue: -0.5, // handicapPrice: 1.85, // isHomeTeamUpper:
true, // predictionType: "body", // predictionSide: "Over 2.5", // score: "3-1",
// status: "full_win", // statusString: "WIN ✅", // }, // { // homeTeam: "AC
Milan", // awayTeam: "Napoli", // handicapValue: 0, // handicapPrice: 1.9, //
isHomeTeamUpper: false, // predictionType: "goal_total", // predictionSide:
"Under 2.5", // score: "1-0", // status: "full_win", // statusString: "WIN ✅",
// }, // { // homeTeam: "Barcelona", // awayTeam: "Atletico Madrid", //
handicapValue: -1, // handicapPrice: 2.1, // isHomeTeamUpper: true, //
predictionType: "body", // predictionSide: "Home Win", // score: "2-2", //
status: "lose", // statusString: "LOSE ❌", // }, // { // homeTeam: "PSG", //
awayTeam: "Lyon", // handicapValue: -0.5, // handicapPrice: 1.7, //
isHomeTeamUpper: true, // predictionType: "body", // predictionSide: "Home Win",
// score: "2-0", // status: "full_win", // statusString: "WIN ✅", // }, // { //
homeTeam: "Chelsea", // awayTeam: "Man City", // handicapValue: 0.5, //
handicapPrice: 1.95, // isHomeTeamUpper: false, // predictionType: "goal_total",
// predictionSide: "Over 2.5", // score: "2-3", // status: "partial_win", //
statusString: "WIN ✅", // }, // ], // }
